/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FixSageSyncAnalysisIssuesInput = {|
  companyId?: ?number,
  ids?: ?$ReadOnlyArray<?string>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type fixSageSyncAnalysisIssuesMutationVariables = {|
  input: FixSageSyncAnalysisIssuesInput
|};
export type fixSageSyncAnalysisIssuesMutationResponse = {|
  +fixSageSyncAnalysisIssues: ?{|
    +ids: ?$ReadOnlyArray<?string>
  |}
|};
export type fixSageSyncAnalysisIssuesMutation = {|
  variables: fixSageSyncAnalysisIssuesMutationVariables,
  response: fixSageSyncAnalysisIssuesMutationResponse,
|};
*/


/*
mutation fixSageSyncAnalysisIssuesMutation(
  $input: FixSageSyncAnalysisIssuesInput!
) {
  fixSageSyncAnalysisIssues(input: $input) {
    ids
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "FixSageSyncAnalysisIssuesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FixSageSyncAnalysisIssuesPayload",
    "kind": "LinkedField",
    "name": "fixSageSyncAnalysisIssues",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ids",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fixSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fixSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "fixSageSyncAnalysisIssuesMutation",
    "operationKind": "mutation",
    "text": "mutation fixSageSyncAnalysisIssuesMutation(\n  $input: FixSageSyncAnalysisIssuesInput!\n) {\n  fixSageSyncAnalysisIssues(input: $input) {\n    ids\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fbdbcc7e965c2b68d08905946e79db44';

module.exports = node;
